import React from 'react';
import { FormHelperText, Typography } from '@mui/material';
import type { BillingMode } from '../../../types/admin';
import { billingModeNote } from './billingModeNoteText';
interface BillingModeNoteProps {
  mode: BillingMode;
  variant?: 'helper' | 'body';
}
export const BillingModeNote: React.FC<BillingModeNoteProps> = ({ mode, variant = 'helper' }) => {
  const text = billingModeNote(mode);
  if (!text) return null;
  return variant === 'body' ? (
    <Typography variant="caption" className="text-gray-500 dark:text-slate-400">
      {text}
    </Typography>
  ) : (
    <FormHelperText>{text}</FormHelperText>
  );
};
